import type { Db } from "./db.ts";

/**
 * Picks the data backend. The in-memory demo is only possible in a dev build
 * (`npm run dev` with VITE_DEMO=1); a production build always uses Supabase.
 */
export async function openDb(): Promise<Db> {
  const env = import.meta.env;
  if (env.DEV && env.VITE_DEMO === "1") {
    const { MemoryDb } = await import("./memory-db.ts");
    const { seedDemo } = await import("./demo-seed.ts");
    const db = new MemoryDb();
    await seedDemo(db);
    return db;
  }
  const url = env.VITE_SUPABASE_URL;
  const key = env.VITE_SUPABASE_ANON_KEY;
  if (!url || !key) throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY; see apps/audit/.env.example");
  const { SupabaseDb } = await import("./supabase-db.ts");
  return new SupabaseDb(url, key);
}
